<script setup lang="ts">
import { computed } from 'vue';
import { useGameStore } from '@/stores/game';

const gameStore = useGameStore();

const currentLevelValue = computed(() => {
    const question = gameStore.currentQuestion;
    if (!question || !question.game_details || !question.game_details.settings) {
        return 'N/A';
    }

    const settings = question.game_details.settings;
    const frameIndex = gameStore.currentImageFrame;
    let sequence: unknown[] = [];

    if (question.game_type === 'zoom_out') {
        sequence = settings.zoom_level_sequence || [];
    } else if (question.game_type === 'resolution') {
        sequence = settings.blur_levels || [];
    } else if (question.game_type === 'noise') {
        sequence = settings.noise_levels || [];
    }

    if (frameIndex >= 0 && frameIndex < sequence.length) {
        return sequence[frameIndex];
    }
    return 'Out of bounds';
});
</script>

<template>
    <div class="debug-overlay">
        <div class="debug-title">🔧 DEBUG MODE</div>
        <div class="debug-info">
            <div class="debug-item">
                <span class="label">Game Type:</span>
                <span class="value">{{ gameStore.currentQuestion?.game_type || 'None' }}</span>
            </div>
            <div class="debug-item">
                <span class="label">Frame:</span>
                <span class="value">{{ gameStore.currentImageFrame + 1 }} / {{ gameStore.totalImageFrames }}</span>
            </div>
            <div class="debug-item">
                <span class="label">Value:</span>
                <span class="value">{{ currentLevelValue }}</span>
            </div>
            <div class="debug-item">
                <span class="label">Time:</span>
                <span class="value">{{ gameStore.remainingTime.toFixed(2) }}s</span>
            </div>
            <div class="debug-item">
                <span class="label">State:</span>
                <span class="value">{{ gameStore.isAnswered ? 'Answered' : 'Playing' }}</span>
            </div>
        </div>
    </div>
</template>

<style scoped>
.debug-overlay {
    position: fixed;
    top: 50px;
    right: 10px;
    background-color: rgba(0, 0, 0, 0.85);
    color: #0f0;
    padding: 10px;
    border-radius: 5px;
    font-family: 'Courier New', Courier, monospace;
    z-index: 9999;
    border: 1px solid #0f0;
    pointer-events: none;
    /* クリックを邪魔しないように */
    min-width: 200px;
    box-shadow: 0 0 10px rgba(0, 255, 0, 0.2);
}

.debug-title {
    font-weight: bold;
    border-bottom: 1px solid #0f0;
    margin-bottom: 8px;
    padding-bottom: 4px;
    text-align: center;
    font-size: 1.1em;
}

.debug-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
    font-size: 0.9em;
}

.label {
    margin-right: 15px;
    color: #888;
}

.value {
    font-weight: bold;
    color: #fff;
}
</style>
